import React from "react";
import classes from "../MainTitle.module.scss";
import {
  NO_ASIDE_CLASS,
  HAS_ASIDE_CLASS,
  NO_ASIDE_CLASS_FULL,
} from "../../../../constants/defaults";

const MainTitlePurple = ({
  children,
  full,
  hasAside,
  // hasBG,
  rightArea,
  title,
  yellowBG,
}) => {
  const areaClass = hasAside
    ? classes.WithAside + " " + HAS_ASIDE_CLASS
    : full
      ? NO_ASIDE_CLASS_FULL
      : NO_ASIDE_CLASS;

  let marginBottom = "";
  // if (hasBG)
  //   hasBG = (
  //     <section className={classes.AreaBg}>
  //       <div className={classes.BgTopColored}></div>
  //     </section>
  //   );
  // else
  marginBottom = classes.MarginBottom;

  const _btnRight = rightArea ? rightArea : null;
  const yellowCalss = yellowBG ? classes.Yellow : "";
  return (
    <header
      className={
        classes.MainTitle + " col-12 " + marginBottom + " " + yellowCalss
      }
    >
      <div className="row">
        {/* {hasBG} */}
        <section className={areaClass}>

          <div className={classes.AreaTitle}>
            <h1 className={classes.Title}>{title}</h1>
            <div className={classes.RightArea}>{_btnRight}</div>
          </div>
          {children}
        </section>
      </div>
    </header>
  );
};

export default MainTitlePurple;
